import './App.css';
import logo from './assets/logo-soilthm.png';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <header className="header">
        <div className="logo-container">
          <img src={logo} alt="Soilthm logo" className="logo-image" />
          <span className="logo-text">Soilthm</span>
        </div>
        <a href="mailto:contato@soilthm.com">
          <button className="cta-button">Solicitar orçamento</button>
        </a>
      </header>

      <main style={{ flex: 1 }}>
        <section className="hero">
          <h1>A tecnologia na sua empresa</h1>
          <p>Consultoria em tecnologia, desenvolvimento de sistemas personalizados e soluções PDV para lojas físicas e online.</p>
          
          <a href="mailto:contato@soilthm.com">
            <button className="cta-button">Fale conosco</button>
          </a>
        </section>

        <section className="section">
          <h2>Serviços</h2>
          <div className="services">
            <div className="service-card">
              <h3>Consultoria de Tecnologia</h3>
              <p>Diagnóstico e orientação para tomada de decisões eficientes em sua empresa.</p>
            </div>
            <div className="service-card">
              <h3>Sistemas Sob Demanda</h3>
              <p>Software personalizado para atender os objetivos da sua empresa.</p>
            </div>
            <div className="service-card">
              <h3>PDVs e Estoque</h3>
              <p>Soluções completas para varejo seja físico ou online.</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        &copy; 2025 Soilthm - Todos os direitos reservados.
      </footer>
    </div>
  );
}

export default App;
